import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";
import {
    EVENT_PRODUCT_GRID,
    CLOSE_FILTER,
    OPEN_FILTER,
} from "@hermes/states/grid-filters-state";

export interface GridFilterToggleEventPayload {
    closed: boolean;
    filterName: string;
}

export class GridFilterToggleEvent implements AnalyticsEvent<GTMEventData> {
    public name: string = EVENT_UAEVENT;

    public eventData: GridFilterToggleEventPayload;

    constructor(data: GridFilterToggleEventPayload) {
        this.eventData = data;
    }

    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: EVENT_PRODUCT_GRID,
            eventaction: this.eventData.closed ? CLOSE_FILTER : OPEN_FILTER,
            eventlabel: this.eventData.filterName,
        };
    }
}
